/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { UpdateUserForAdminAction, UpdateUserForAdminActionTypes } from './types';

export interface UpdateUserForAdminState {
  loading: boolean;
  error?: Error;
  success: boolean;
}

export const initialUpdateUserForAdminState: UpdateUserForAdminState = {
  loading: false,
  error: undefined,
  success: false,
};

export default function updateUserForAdminReducer(
  state = initialUpdateUserForAdminState,
  action: UpdateUserForAdminAction,
) {
  switch (action.type) {
    case UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_REQUEST:
      return update(state, {
        loading: { $set: true },
        success: { $set: false },
      });

    case UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_SUCCESS:
      return update(state, {
        loading: { $set: false },
        success: { $set: true },
      });

    case UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_ERROR:
      return update(state, {
        loading: { $set: false },
        success: { $set: false },
        error: { $set: action.error },
      });

    case UpdateUserForAdminActionTypes.RESET_ERROR:
      return update(state, {
        $unset: ['error'],
      });

    case UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_RESET:
      return initialUpdateUserForAdminState;

    default:
      return state;
  }
}
